module.exports = __webpack_public_path__ + "static/media/ArialMTBold.80834698.woff";